module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "epub:type": "toc",
      "id": "_idContainer006"
    }
  }, [_c('h1', {
    staticClass: "Front-Title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D2#_idTextAnchor000"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D3#_idTextAnchor001"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D4#_idTextAnchor002"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D5#_idTextAnchor003"
    }
  }, [_vm._v("Breads & Toppings")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D5#_idTextAnchor004"
    }
  }, [_vm._v("Sweet Potato Buttermilk Biscuits")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D5#_idTextAnchor005"
    }
  }, [_vm._v("Ramp Buttermilk Biscuits")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D5#_idTextAnchor006"
    }
  }, [_vm._v("Panettone Grand Marnier French Toast")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D5#_idTextAnchor007"
    }
  }, [_vm._v("Hot Cross Buns")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D5#_idTextAnchor008"
    }
  }, [_vm._v("Brisket-Stuffed Herb Cornbread")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D5#_idTextAnchor009"
    }
  }, [_vm._v("Rum, Date, and Walnut Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D5#_idTextAnchor010"
    }
  }, [_vm._v("Garlic-Infused Olive Oil ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D5#_idTextAnchor011"
    }
  }, [_vm._v("Quince Jam")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D5#_idTextAnchor012"
    }
  }, [_vm._v("Easy Meyer Lemon Marmalade")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D5#_idTextAnchor013"
    }
  }, [_vm._v("Hot Curried Peaches")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D5#_idTextAnchor014"
    }
  }, [_vm._v("Homemade Sweet and Savory Bourbon Syrup")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D5#_idTextAnchor015"
    }
  }, [_vm._v("Flavored Butters")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D6#_idTextAnchor017"
    }
  }, [_vm._v("Starters")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D6#_idTextAnchor018"
    }
  }, [_vm._v("Smoked Salmon Blinis")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D6#_idTextAnchor019"
    }
  }, [_vm._v("Country-Style Pâté")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D6#_idTextAnchor020"
    }
  }, [_vm._v("Spicy Marinated Olives")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D6#_idTextAnchor021"
    }
  }, [_vm._v("Brie, Fig, and Walnut Crostini")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D6#_idTextAnchor022"
    }
  }, [_vm._v("Crab-Stuffed Mushrooms")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D6#_idTextAnchor023"
    }
  }, [_vm._v("Tomato Bruschetta")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D6#_idTextAnchor024"
    }
  }, [_vm._v("Bacon Deviled Eggs")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D6#_idTextAnchor025"
    }
  }, [_vm._v("Coquilles St. Jacques")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D6#_idTextAnchor026"
    }
  }, [_vm._v("Endive, Pear, and Goat Cheese Boats")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D6#_idTextAnchor027"
    }
  }, [_vm._v("Jumbo Shrimp and Lump Crab with Vodka Cocktail Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D6#_idTextAnchor028"
    }
  }, [_vm._v("Avocado Toast Points")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D6#_idTextAnchor029"
    }
  }, [_vm._v("Cheesy Grit Cakes")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D6#_idTextAnchor030"
    }
  }, [_vm._v("Caramelized Onions and Feta Mini Tarts")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D7#_idTextAnchor031"
    }
  }, [_vm._v("Egg Dishes")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D7#_idTextAnchor032"
    }
  }, [_vm._v("Spinach and Goat Cheese Eggs Florentine with Hollandaise Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D7#_idTextAnchor033"
    }
  }, [_vm._v("Mushroom, Ham, and Bell Pepper Omelet")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D7#_idTextAnchor034"
    }
  }, [_vm._v("Loaded Steak and Bell Pepper Strata")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D7#_idTextAnchor035"
    }
  }, [_vm._v("Fluffy Scrambled Eggs onTexas Toast with Swiss Cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D7#_idTextAnchor036"
    }
  }, [_vm._v("Italian Baked Eggs and Sausage in Marinara Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D7#_idTextAnchor037"
    }
  }, [_vm._v("Salmon-Asparagus Quiche")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D7#_idTextAnchor038"
    }
  }, [_vm._v("Spinach-Chorizo Frittata")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D7#_idTextAnchor039"
    }
  }, [_vm._v("Sausage, Cheddar, and Polenta Soufflé")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D8#_idTextAnchor040"
    }
  }, [_vm._v("Soups, Salads & Sandwiches")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D8#_idTextAnchor041"
    }
  }, [_vm._v("Fiery Stout Chili")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D8#_idTextAnchor042"
    }
  }, [_vm._v("Roasted Butternut Squash Soup with Scallops")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D8#_idTextAnchor043"
    }
  }, [_vm._v("Avocado BLT")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D8#_idTextAnchor044"
    }
  }, [_vm._v("Seafood Chowder ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D8#_idTextAnchor045"
    }
  }, [_vm._v("Simple Butter Lettuce Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D8#_idTextAnchor046"
    }
  }, [_vm._v("Creamy Tomato Soup with Crostini Cheese Toast")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D8#_idTextAnchor047"
    }
  }, [_vm._v("Crab Louie Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D8#_idTextAnchor048"
    }
  }, [_vm._v("Sausage, Lentil, and Bacon Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D8#_idTextAnchor049"
    }
  }, [_vm._v("Egg, Prosciutto, Tomato, and Arugula Panini")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D8#_idTextAnchor050"
    }
  }, [_vm._v("Grit Cake, Collard, and Pulled Pork Sammie")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D8#_idTextAnchor051"
    }
  }, [_vm._v("Croque Madame")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D8#_idTextAnchor052"
    }
  }, [_vm._v("Egg, Bacon, and Cheese Brunch Burger")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D8#_idTextAnchor053"
    }
  }, [_vm._v("Spicy Egg and Chicken Wraps")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D9#_idTextAnchor054"
    }
  }, [_vm._v("Vegetables & Sides")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D9#_idTextAnchor055"
    }
  }, [_vm._v("Roasted Brussels Sprouts and Carrots with Pancetta")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D9#_idTextAnchor056"
    }
  }, [_vm._v("Oven-Roasted Root Vegetables")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D9#_idTextAnchor057"
    }
  }, [_vm._v("Collard Greens and Rice Casserole")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D9#_idTextAnchor058"
    }
  }, [_vm._v("Mediterranean Stuffed Tomatoes")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D9#_idTextAnchor059"
    }
  }, [_vm._v("Roasted Stuffed Zucchini Boats")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D9#_idTextAnchor060"
    }
  }, [_vm._v("Wilted Spinach and Arugula with Toasted Pine Nuts")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D9#_idTextAnchor061"
    }
  }, [_vm._v("Fried Green Tomatoes with Aioli")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D9#_idTextAnchor062"
    }
  }, [_vm._v("Southern-Style Succotash")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D9#_idTextAnchor063"
    }
  }, [_vm._v("Sweet Potato Medallions with Currants and Pecans")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D9#_idTextAnchor064"
    }
  }, [_vm._v("Cheesy Jalapeño Grits")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D10#_idTextAnchor065"
    }
  }, [_vm._v("Pasta & Casseroles")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D10#_idTextAnchor066"
    }
  }, [_vm._v("Boeuf Bourguignon")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D10#_idTextAnchor067"
    }
  }, [_vm._v("Breakfast Macaroni and Cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D10#_idTextAnchor068"
    }
  }, [_vm._v("Chicken Vesuvio")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D10#_idTextAnchor069"
    }
  }, [_vm._v("Grilled Eggplant, Tomato, and Pancetta Pasta ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D10#_idTextAnchor070"
    }
  }, [_vm._v("Seafood and Chicken Paella ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D10#_idTextAnchor071"
    }
  }, [_vm._v("Scallops, Mussels, and Shrimp Bucatini")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D10#_idTextAnchor072"
    }
  }, [_vm._v("Alfredo Seafood Lasagna")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D11#_idTextAnchor073"
    }
  }, [_vm._v("Main Courses & Meats")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D11#_idTextAnchor074"
    }
  }, [_vm._v("Flavored and Spiced Bacons")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D11#_idTextAnchor075"
    }
  }, [_vm._v("Breakfast Steak and Eggs on Asparagus Spears")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D11#_idTextAnchor076"
    }
  }, [_vm._v("Grilled Prawns on Rosemary Skewers with Lemon Butter Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D11#_idTextAnchor077"
    }
  }, [_vm._v("Oven-Roasted Pulled Pork")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D11#_idTextAnchor078"
    }
  }, [_vm._v("Honey Dijon-Glazed Ham Steak")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D11#_idTextAnchor079"
    }
  }, [_vm._v("Shrimp-Andouille Grits with Okra")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D11#_idTextAnchor080"
    }
  }, [_vm._v("Lemon-Garlic Baked Cod")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D11#_idTextAnchor081"
    }
  }, [_vm._v("Red Velvet and Pecan Waffles with Fried Chicken ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D11#_idTextAnchor082"
    }
  }, [_vm._v("Homemade Rosemary Pork Sausage Patties")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D11#_idTextAnchor083"
    }
  }, [_vm._v("Blackened Catfish on Herb Grits with Pineapple Relish")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D11#_idTextAnchor084"
    }
  }, [_vm._v("New Orleans-Style Barbecue Shrimp")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D11#_idTextAnchor085"
    }
  }, [_vm._v("Slow-Roasted Beef Brisket")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D12#_idTextAnchor086"
    }
  }, [_vm._v("Desserts")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D12#_idTextAnchor087"
    }
  }, [_vm._v("Blueberry-Almond Puff Tarts")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D12#_idTextAnchor088"
    }
  }, [_vm._v("Lemon Curd and Gingersnap Trifle")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D12#_idTextAnchor089"
    }
  }, [_vm._v("Triple Peanut Butter and Chocolate Cheesecake ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D12#_idTextAnchor091"
    }
  }, [_vm._v("Rum—Chocolate Chip Pecan Pie")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D12#_idTextAnchor092"
    }
  }, [_vm._v("Black Walnut–Cardamom Pound Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D12#_idTextAnchor093"
    }
  }, [_vm._v("Quince Crisp")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D12#_idTextAnchor094"
    }
  }, [_vm._v("Croissant, Pear, and Chocolate Bread Pudding")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D12#_idTextAnchor095"
    }
  }, [_vm._v("Baba Au Rhum")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D12#_idTextAnchor096"
    }
  }, [_vm._v("Savory Spice Olive Oil Loaf Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D12#_idTextAnchor097"
    }
  }, [_vm._v("Tarte Tatin ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D13#_idTextAnchor098"
    }
  }, [_vm._v("Brunch Cocktails")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D13#_idTextAnchor099"
    }
  }, [_vm._v("Pomegranate Mimosa ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D13#_idTextAnchor100"
    }
  }, [_vm._v("Bellini ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D13#_idTextAnchor101"
    }
  }, [_vm._v("Chef Belinda’s Creole Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D13#_idTextAnchor102"
    }
  }, [_vm._v("Grapefruit, Champagne, and Vodka Spritz")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D13#_idTextAnchor103"
    }
  }, [_vm._v("Blood Orange Screwdriver ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D13#_idTextAnchor104"
    }
  }, [_vm._v("Cucumber Cooler")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D13#_idTextAnchor105"
    }
  }, [_vm._v("Kir Royale ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D13#_idTextAnchor106"
    }
  }, [_vm._v("Mint Julep")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D13#_idTextAnchor107"
    }
  }, [_vm._v("Bourbon Lemon Drop ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D13#_idTextAnchor108"
    }
  }, [_vm._v("Simple Syrup")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC-head1"
  }, [_c('a', {
    attrs: {
      "href": "#/LetsBrunchInteriors_D13#_idTextAnchor109"
    }
  }, [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8843db86","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Lets-Brunch-Interiors_D-1.vue
// module id = 63
// module chunks = 0